export default function getResource(label, vars = []) {
    const resources = {
        modalTitle: 'Phone Verification',
        heading: 'Help Us Keep Your Account Secure',
        otpHeading: 'Check your messages and enter your verification code',
        subheading: 'For enhanced account security, we need to verify your phone number.',
        otpSubheading: 'You will receive a code at',
        otpSubheadingCont: 'if it is registered with a Beauty Insider account.',
        phoneOnFilePrefix: 'Confirm the number ending in',
        phoneOnFileSuffix: 'to receive a one-time passcode.',
        enterPhoneNumber: 'Phone Number',
        sendButton: 'Send',
        cancelButton: 'Cancel',
        resendButton: 'Resend',
        noAccessTextPrefix: 'No access to this phone? Send one-time passcode to ',
        sendToEmailButton: 'Send to Email',
        emailVerification: 'Email Verification',
        privacyNote: 'The information collected here will only be used for verification purposes. Message and data rates may apply. By clicking "Send", your (1) agree to the current version of our ',
        termsOfUse: 'TERMS OF USE',
        privacyNoteEnd: ', and (2) have read Sephora\'s ',
        privacyPolicy: 'Privacy Policy',
        errorInvalidPhone: 'Please enter a valid phone number.',
        errorPhoneMismatch: 'The number you entered is incorrect. Please try again.',
        tooManyAttempts: 'Too Many Attempts',
        errorMaxAttempts: 'Incorrect phone number and attempts, please use email verification to complete sign-in or try again later.',
        errorProfileNotFound: 'Profile not found. Please check your email and try again.',
        errorTokenExpired: 'Your session has expired. Please sign in again.',
        errorInvalidEmail: 'Email is invalid.',
        errorMissingParameters: 'Missing mandatory input parameters.',
        errorInternalServer: 'An error occurred during verification. Please try again later.',
        errorNetwork: 'Unable send a one time passcode to your phone at this time, please use email verification to complete sign-in or try again later.',
        remainingAttempts: `${vars[0]} attempt${vars[0] === 1 ? '' : 's'} remaining`,
        sending: 'Sending...',
        accessibilityPhoneInput: 'Enter your phone number for verification',
        accessibilityError: 'Error',
        needAnotherSms: 'Need another SMS?',
        didntGetSms: 'Didn\'t get the SMS? Resend code in',
        seconds: 'seconds',
        errorInvalidOtp: 'The code you entered is incorrect. Please check and try again.',
        errorInternalServerOTP: 'We\'re unable to confirm your one time passcode at this time. Please try again later.',
        errorMaxAttemptOtp: 'Too many attempts. Please try again later.',
        gotIt: 'Got It',
        expiredOTPTitle: 'Expired Passcode',
        expiredOTP: 'The code you entered has expired. Please resend another code.',
        sendNewCode: 'Send New Code',
        infoTitle: 'Help us keep your account secure',
        infoMessage: 'This helps us ensure that only you have access to your account and protects your information from unauthorized access.'

    };

    return resources[label];
}
